import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureWhistleloopClickId, isMetaSource } from '../Utils/whistleloopPixel';
import { captureUtmParams } from '../Utils/utm';

const META_PIXEL_ID = '912649253950133';

// Dynamically loads Meta pixel script, inits it, and fires PageView.
// Only called when isMetaSource() is true — pixel won't appear at all for other traffic.
const loadMetaPixel = (pixelId) => {
  if (window.fbq) {
    window.fbq('track', 'PageView');
    return;
  }
  try {
    const f = window;
    f.fbq = function () {
      f.fbq.callMethod
        ? f.fbq.callMethod.apply(f.fbq, arguments)
        : f.fbq.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = f.fbq;
    f.fbq.push = f.fbq;
    f.fbq.loaded = true;
    f.fbq.version = '2.0';
    f.fbq.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  } catch (e) {
    console.warn('[PixelTracker] Meta pixel load failed:', e?.message || e);
  }
};

const PixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Capture a tracked link on whichever page the visitor lands on, so the attribution
    // is already stored when they click through to Apply Now (which has no query string).
    captureUtmParams();

    // ─── 1. Meta Pixel: only load & fire for Meta / Facebook traffic ───
    if (isMetaSource()) {
      loadMetaPixel(META_PIXEL_ID);
    }

    // ─── 2. Whistleloop: click_id capture ───
    try {
      captureWhistleloopClickId();
    } catch (e) {
      console.warn("[PixelTracker] Whistleloop click_id capture failed:", e?.message || e);
    }

  }, [location]);

  return null;
};

export default PixelTracker;